import React from "react";
import aeroflex from "../homeimg/aeroflex.png";
import zeco from "../homeimg/zeco.png";
// import phoenix from "../homeimg/phoenix.png";
// import agilon from "../homeimg/agilon.png";
import trf from "../homeimg/trf.png";
// import lubi from "../homeimg/lubi.png";
import advance from "../homeimg/advance.png";
import kflex from "../homeimg/kflex.png";
import belimo from "../homeimg/belimo.png";
// import mechmarkk from "../homeimg/mechmaark.png";
import acrenof from "../homeimg/acreconf.png";
import ventconf from "../homeimg/ventconf.png";
import truestar from "../homeimg/truestar.png";
import avantec from "../homeimg/avantec.png";
import greenoz from "../homeimg/greenoz.png";
import totalsecurity from "../homeimg/total-security.png";
import climatesummit from '../homeimg/climate-summit.webp'
import vts from '../partnerPharmaConnect/vts.png'
import kptPipes from '../partnerPharmaConnect/kpt-pipes.webp'
import princePipe from '../partnerPharmaConnect/prince-pipes.webp'
import camfil from '../partnerPharmaConnect/camfil-clear-air-solution.webp'
import fusionPipes from '../partnerPharmaConnect/fusion-pipes.webp'
import hitachi from '../partnerPharmaConnect/hitachi-cool-heating.webp'
import danfoss from '../partnerPharmaConnect/danfoss.webp'
import ultrapure from '../partnerPharmaConnect/ultrapure.webp'
import shk from '../partnerPharmaConnect/shk-ppr-pipes.webp'
import lenze from '../partnerPharmaConnect/lenze.webp'
import casilica from '../partnerPharmaConnect/casilica.webp'
import perfectAir from '../partnerPharmaConnect/perfect-air.webp'
import vtm from '../partnerPharmaConnect/vtm-industrial-values.webp'
import armacell from '../partnerPharmaConnect/armacell.webp'
import sml from '../partnerPharmaConnect/sml-clean-room-solution.webp'
import carrier from '../homeimg/carrier.png'
import zenvirn from '../homeimg/zenvirn.png'
import aditya from '../homeimg/aditya.png'
import blowtech from '../homeimg/blowtech.png'
import "./partners.css";
const Partners = () => {
  return (
    <>
      <div id="partners" className="container">
        <div className="sm:w-1/2 xl:w-1/3 mx-auto text-center mb-6 md:mb-12">
          <h1
            style={{ textDecoration: "none " }}
            className="mb-6 font-semibold md:text-2xl md:leading-tight text-gray-800 dark:text-neutral-200"
          >
            Femtech Partners
          </h1>
        </div>

        <div
          id="partnerslogo"
          className="max-w-[95rem] d-flex px-4 py-10 sm:px-6 lg:px-8 lg:py-14 "
        >
         
          <h2 className="text-center mt-5 mb-5">Gold Partner</h2>
          <div
            id="silverpartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
           
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={carrier} alt="carrier" />
            </div>
           
          
          </div>
          <hr />
          <h2 className="text-center mt-5 mb-5">Women Empowerment Partner</h2>
          <div
            id="silverpartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
           
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={zenvirn} alt="zenviron" />
            </div>
           
          
          </div>
          <hr />
          


         <h2 className="text-center mt-5 mb-5 ">Natworking Partners </h2>
          <div
            id="goldpartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={aditya} alt="aditya" />
            </div>

            {/* <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={zeco} alt="zeco" />
            </div> */}

          

            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={blowtech} alt="blowtech" />
            </div>
          </div>
          <hr/>
         
        </div>
        
      </div>

      
      <div id="partners" className="container">
        <div className="sm:w-1/2 xl:w-1/3 mx-auto text-center mb-6 md:mb-12">
          <h1
            style={{ textDecoration: "none " }}
            className="mb-6 font-semibold md:text-2xl md:leading-tight text-gray-800 dark:text-neutral-200"
          >
            Our Annual Partners
          </h1>
        </div>

        <div
          id="partnerslogo"
          className="max-w-[95rem] d-flex px-4 py-10 sm:px-6 lg:px-8 lg:py-14 "
        >
          <h2 className="text-center mt-5 mb-5 ">Gold Partners</h2>
          <div
            id="goldpartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={aeroflex} alt="aeroflex" />
            </div>

            {/* <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={zeco} alt="zeco" />
            </div> */}

          

            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={advance} alt="advance" />
            </div>
          </div>
          <hr />
          <h2 className="text-center mt-5 mb-5">Silver Partners</h2>
          <div
            id="silverpartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
           
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={trf} alt="trf" />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={belimo} alt="belimo" />
            </div>
          
          </div>
          <hr />
          <h2 className="text-center mt-5 mb-5">Bronze Partners</h2>
          <div
            id="bronzepartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={greenoz} alt="greenoz" />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={totalsecurity} alt="totalsecurity" />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={zeco} alt="zeco" />
            </div>

            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={kflex} alt="kflex" />
            </div>

            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={truestar} alt="truestar" />
            </div>

            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img src={avantec} alt="avantec" />
            </div>
          
          </div>
          <hr />
        </div>
        {/* <div className="sm:w-1/2 xl:w-1/3 mx-auto mt-5 text-center mb-6 md:mb-12">
          <h1
            style={{ textDecoration: "none " }}
            className="mb-6 font-semibold md:text-2xl md:leading-tight text-gray-800 dark:text-neutral-200"
          >
            Our Pharma Connect Partners
          </h1>
        </div> */}

        <div
          id="partnerslogo"
          className="max-w-[95rem] d-flex px-4 py-10 sm:px-6 lg:px-8 lg:py-14 "
        >
          {/* <h2 className="text-center mt-5 mb-5 ">Title Partners</h2> */}
          {/* <div
            id="goldpartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6">
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={elgi}
                alt="kehems"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
          </div> */}
          {/* <hr />
          <h2 className="text-center mt-5 mb-5">Gold Partners</h2>
          <div
            id="silverpartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={kirloskar}
                alt="blaze"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
          </div> */}
          {/* <hr />
          <h2 className="text-center mt-5 mb-5">Registration Partners</h2>
          <div
            id="bothpartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={climcone}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
          </div>
          <hr /> */}
          {/* <h2 className="text-center mt-5 mb-5">Technology Partners</h2>
          <div
            id="bothpartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={vts}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={shk}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={vasu}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={trueStar}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
          </div>
          <hr /> */}
          {/* <h2 className="text-center mt-5 mb-5">Booth Partners</h2>
          <div
            id="bothpartner"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={revo}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={casilica}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={advanceValues}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={aditya}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={ae}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
            <div className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800">
              <img
                src={bryair}
                alt="brydri"
                style={{ width: "180px", height: "90px" }}
              />
            </div>
          </div>
          <hr /> */}
        </div>
      </div>

      <div id="events" className="container">
        <div className="sm:w-1/2 xl:w-1/3 mx-auto text-center mb-6 md:mb-12">
          <h1
            style={{ textDecoration: "none" }}
            className="mb-4 font-semibold md:text-2xl md:leading-tight text-gray-800 dark:text-neutral-200"
          >
            Our Events
          </h1>
        </div>

        <div
          id="eventslogo"
          className="max-w-[95rem] d-flex px-4 py-10 sm:px-6 lg:px-8 lg:py-14 "
        >
          <div
            id="allevents"
            className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 gap-3 lg:gap-6"
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800"
            >
              <a href="https://climatesummit.co.in/" target="_blank" rel="noreferrer">

              <img src={climatesummit} alt="climatesummit" />
              </a>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800"
            >
              <img src={acrenof} alt="acrenof" />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="p-3 md:p-7 bg-gray-100 rounded-lg dark:bg-neutral-800"
            >
              <img src={ventconf} alt="ventconf" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Partners;